var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecked2 = function SvgChecked2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.87 9.275a1.326 1.326 0 0 0 .193-1.534 1.4 1.4 0 0 0-.352-.423 1.471 1.471 0 0 0-1.593-.15 1.4 1.4 0 0 0-.431.351l-6.114 7.078-3.163-3.054a1.45 1.45 0 0 0-1-.385c-.373.003-.73.147-.994.402a1.35 1.35 0 0 0-.416.958c-.003.36.14.706.4.965l4.264 4.116a1.469 1.469 0 0 0 1.637.258c.177-.085.334-.204.46-.35z",
    clipRule: "evenodd"
  })));
};
export { SvgChecked2 as ReactComponent };